
export const capitalize = (text: string): string => (
  // accepts string, e.g. 'full-name' or 'full name' or 'full_name'
  // outputs capitalized and spaced, e.g. 'Full Name'
  text.split('-' || '_' || ' ').map((word) => (
    `${word[0].toUpperCase()}${word.substr(1)}`
  )).join(' ')
);

export const trimProps = (props: object, attributesToRemove: string): object => {
  const updatedProps = { ...props };

  Object.keys(updatedProps).forEach((key) => {
    if (attributesToRemove.split(',').includes(key)) {
      delete updatedProps[key];
    }
  });

  return updatedProps;
};
